
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[group]",
      function () {
        return require("private-next-pages/docs/[group]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[group]"])
      });
    }
  